<template>
    <div>

        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <b-table
            :busy="isBusy"
            :fields="fields"
            :items="filteredItems"
            sticky-header="500px"
            responsive
            no-border-collapse
            select-mode="single"
            selectable
            @row-selected="onRowSelected"
            show-empty            
        >

            <template #empty>
                <b-card v-if="items.length !== 0" class="text-center my-2 fs-5">
                    No hay usuarios que coincidan con los criterios de búsqueda
                </b-card>
                <b-card v-else class="text-center my-2 fs-5">
                    Aún no se ha creado ningún usuario
                </b-card>
            </template>

            <!--icono de carque de tabla-->
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando datos de tabla...</strong>
                </div>
            </template>

            <!--botones de eliminar y editar -->
            <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                    <b-button
                        @click="openModalEditUser()"
                        type="button"
                        variant="outline-success"
                        v-b-tooltip.hover.bottom="'Editar usuario'"
                        size="sm"
                        class="me-2"
                    >
                        <b-icon icon="person-lines-fill" font-scale="1"></b-icon>
                    </b-button>
                    <b-button
                        @click="openModalDeleteUser()"
                        type="button"
                        variant="outline-danger"
                        v-b-tooltip.hover.bottom="'Eliminar usuario'"
                        size="sm"
                    >
                        <b-icon icon="person-dash-fill" font-scale="1"></b-icon>
                    </b-button>
                </template>
                <template v-else>
                    <b-icon icon="three-dots" font-scale="1" class="icone-not-select"></b-icon>
                </template>
            </template>

            <!--boton de detalles -->
            <template #cell(detalle)="row">
                <b-button size="sm" @click="row.toggleDetails" variant="outline-secondary" class="mr-2">
                    <div v-if="row.detailsShowing">
                        <span class="d-none d-md-inline me-2">Ocultar</span>
                        <b-icon icon="eye-slash-fill" font-scale="1"></b-icon>
                    </div>
                    <div v-else>
                        <span class="d-none d-md-inline me-2">Ver</span>
                        <b-icon icon="eye-fill" font-scale="1"></b-icon>
                    </div>
                </b-button>
            </template>

            <!--cuerpo de detalle-->
            <template #row-details="row">
                <b-card>
                    <p>RUT: {{ formattedRut(row.item.rut) }}</p>
                    <hr>
                    
                    <template v-if="row.item.roles.length == 0">
                        Usuario sin roles asignados.
                    </template>
                    <template v-else>
                        Roles asignados:
                        <ul class="mb-0">
                            <li v-bind:key="rol.id" v-for="rol in row.item.roles">
                                {{ rol.nombre }}
                            </li>
                        </ul>
                    </template>
                </b-card>
            </template>

        </b-table>

    </div>
</template>
<script>
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { EventNames } from '@/plugins/enums/index.js'
import { formatRut } from '@/plugins/complianceScripts/index.js'
import config from '@/plugins/config'

export default {
    name: 'TableUser',
    data() {
        return {
            isBusy: false,
            items: [],
            selected: [],

            endDate: null,
            startDate: null,
            searchQuery: '',
            filterRole: [],

            fields: [
                { key: 'nombre', label: 'Nombre' },
                { key: 'apellido', label: 'Apellido' },
                { key: 'correo', label: 'Correo' },
                {
                    key: 'creacionFormat',
                    label: 'Fecha creación',
                    formatter: (value) => {
                        return value;
                    }
                },
                {
                    key: 'modificacionFormat',
                    label: 'Fecha modificación',
                    formatter: (value) => {
                        return value;
                    }
                },
                { key: 'detalle', label: 'Detalle' , thClass: 'col-1' },
                { key: 'selected', label: 'Opciones' , thClass: 'col-1' },
            ]
        }
    },

    async mounted() {

        this.$eventBus.$on(EventNames.PaginationFilterUsers, async (query) => {
            this.processingTable();

            let page = query.page - 1; //se resta 1 por que el indice comienza en 0
            let pageSize = query.pageSize;

            await this.getUsers(page, pageSize);

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.FilterUsersAfterSearch, (query) => {
            this.processingTable();

            this.searchQuery = query

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.FilterUsersAfterFilterDate, (query) => {
            this.processingTable();

            this.endDate = query.endDate;
            this.startDate = query.startDate;

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.CreateUser, async (query) => {
            this.processingTable();

            let page = query.page - 1; //se resta 1 por que el indice comienza en 0
            let pageSize = query.pageSize;

            await this.getUsers(page, pageSize);
            this.$refs.alertDismiss.showAlert('Usuario creado correctamente', 'success');

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.ModifyUser, async (query) => {
            this.processingTable();

            let page = query.page - 1; //se resta 1 por que el indice comienza en 0
            let pageSize = query.pageSize;

            await this.getUsers(page, pageSize);
            this.$refs.alertDismiss.showAlert('Usuario modificado correctamente', 'success');

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.DeleteUser, async (query) => {
            this.processingTable();

            let page = query.page - 1; //se resta 1 por que el indice comienza en 0
            let pageSize = query.pageSize;

            await this.getUsers(page, pageSize);
            this.$refs.alertDismiss.showAlert('Usuario eliminado correctamente', 'success');

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.FilterForRole, (query) => {
            this.processingTable();

            this.filterRole = query.roles;

            this.processingTable();
        });
    },

    components: {
        AlertDismiss
    },

    computed: {
        filteredItems() {
            let filtered = this.items;
            // Filtrar por rango de fechas
            if (this.startDate && this.endDate) {
                filtered = this.filterForData(filtered, this.startDate, this.endDate);
            }

            // Filtrar por búsqueda por nombre, apellido, etc.
            if (this.searchQuery) {
                filtered = this.filterForSearch(filtered, this.searchQuery)
            }

            // Filtrar por búsqueda por rol
            if (this.filterRole.length > 0) {
                filtered = this.filterForRole(filtered, this.filterRole);
            }

            return filtered;
        },
        menuBgColor() {
            return config.theme.menuBackgroundColor;
        }
    },

    methods: {
        ...mapActions(["allUsersForPage"]),

        processingTable() {
            this.isBusy = !this.isBusy
        },

        async getUsers(page, pageSize) {
            this.items = []

            let users = await this.allUsersForPage({
                page: page,
                pageSize: pageSize
            });

            if (users.isError) {
                this.$refs.alertDismiss.showAlert(users.message);
                return;
            }

            let result = users.data.map((user) => {
                return {
                    nombre: user.name,
                    apellido: user.lastName,
                    correo: user.mail,
                    creacionFormat: this.formatDate(user.creationDate) ?? '',
                    modificacionFormat: this.formatDate(user.dateLastModified) ?? '',
                    creacionDate: user.creationDate,
                    id: user.id,
                    roles: user.roles.map((rol) => {
                        return {
                            id: rol.id,
                            nombre: rol.name
                        }
                    }),
                    rut: user.rut
                }
            });

            this.items.push(...result);
        },

        formatDate(date) {
            if (date == null) {
                return;
            }

            // Crear un objeto Date con la fecha y hora ISO
            var fechaHora = new Date(date);

            // Formatear la fecha y hora en un formato legible para el usuario
            var opcionesFormato = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
            return fechaHora.toLocaleDateString('es-ES', opcionesFormato);
        },

        onRowSelected(items) {
            this.selected = items;
        },

        openModalEditUser() {
            this.$eventBus.$emit(EventNames.OpenModalEditUser, this.selected);
        },

        openModalDeleteUser() {
            this.$eventBus.$emit(EventNames.OpenModalDeleteUser, this.selected);
        },

        filterForRole(usuarios, rolesBuscados) {
            // Utilizamos el método filter para iterar sobre el array de usuarios
            return usuarios.filter(usuario => {
                // Utilizamos el método some para verificar si al menos uno de los roles del usuario coincide con los roles buscados
                return usuario.roles.some(rol => rolesBuscados.includes(rol.id));
            });
        },

        filterForSearch(usuarios, searchQuery) {
            const normalizedQuery = searchQuery.toLowerCase().trim();

            return usuarios.filter(item =>
                Object.values(item).some(value =>
                    value.toString().toLowerCase().includes(normalizedQuery)
                )
            );
        },

        filterForData(usuarios, startDate, endDate){
            const startDateTime = new Date(startDate).getTime();
                const endDateTime = new Date(endDate).getTime();

                return usuarios.filter(item => {
                    const itemDateTime = new Date(item.creacionDate).getTime();
                    return itemDateTime >= startDateTime && itemDateTime <= endDateTime;
                });
        },
        formattedRut(rut) {
            return formatRut(rut)
        }
    },
}
</script>
<style scoped>
.icone-not-select {
    color: v-bind(menuBgColor);
}
</style>
